module.exports = __webpack_public_path__ + "static/media/L4.e3ec2ac9.png";